import { createAppAsyncThunk } from "../../../../store/store.types"

export const logout = createAppAsyncThunk<void, void>(
	"auth/logout",
	async (data, { extra }) => {
		extra.localStorage.clear();
	}
)
